import { apiRequest } from "./api";

/**
 * Request an OTP code for password reset.
 * Endpoint: POST /admin/auth/forgot-password/request-otp
 */
export async function requestOtp(email, simulate = false) {
  if (simulate) {
    await new Promise((resolve) => setTimeout(resolve, 800));
    console.log(`[Simulation] Sending OTP to: ${email}`);
    return {
      success: true,
      message: `(Simulated) OTP sent successfully to ${email}.`,
      data: { email, expires_in_seconds: 600 },
    };
  }

  return await apiRequest("/admin/auth/forgot-password/request-otp", {
    method: "POST",
    body: JSON.stringify({ email }),
  });
}

/**
 * Verify the OTP sent to the user.
 * Endpoint: POST /admin/auth/forgot-password/verify-otp
 */
export async function verifyOtp(email, otp, simulate = false) {
  if (simulate) {
    await new Promise((resolve) => setTimeout(resolve, 800));
    console.log(`[Simulation] Verifying OTP: ${otp} for email: ${email}`);
    if (otp === "123456") {
      return {
        success: true,
        message: "(Simulated) OTP verified successfully.",
        data: {
          email,
          reset_token: "simulated-jwt-reset-token-value-xyz",
        },
      };
    } else {
      throw new Error("Invalid verification code. Use '123456' for simulation.");
    }
  }

  return await apiRequest("/admin/auth/forgot-password/verify-otp", {
    method: "POST",
    body: JSON.stringify({ email, otp }),
  });
}

/**
 * Change the password after OTP verification.
 * Endpoint: POST /admin/auth/forgot-password/reset
 */
export async function resetPassword({ email, otp, resetToken, newPassword, confirmPassword, simulate = false }) {
  if (simulate) {
    await new Promise((resolve) => setTimeout(resolve, 1000));
    console.log(`[Simulation] Resetting password for: ${email}`);
    return {
      success: true,
      message: "(Simulated) Password has been reset successfully.",
    };
  }

  return await apiRequest("/admin/auth/forgot-password/reset", {
    method: "POST",
    body: JSON.stringify({
      email,
      reset_token: resetToken || "",
      new_password: newPassword,
      confirm_password: confirmPassword,
    }),
  });
}

/**
 * Change the password for an authenticated user.
 * Endpoint: POST /admin/auth/change-password
 */
export async function changeAuthenticatedPassword({ currentPassword, newPassword, confirmPassword, simulate = false }) {
  if (simulate) {
    await new Promise((resolve) => setTimeout(resolve, 1000));
    console.log(`[Simulation] Changing authenticated password`);
    if (currentPassword === "wrong") {
      throw new Error("The current password you entered is incorrect. (Use any other string for success)");
    }
    return {
      success: true,
      message: "(Simulated) Password changed successfully.",
    };
  }

  return await apiRequest("/admin/auth/change-password", {
    method: "POST",
    body: JSON.stringify({
      current_password: currentPassword,
      new_password: newPassword,
      confirm_password: confirmPassword,
    }),
  });
}
